module.exports = __webpack_public_path__ + "media/images/icons/icn_050-811a967da965cc35856d7055948f6ec9.svg";